import type { DesignTokens } from '@vibesites/tokens';
import { tokens as parentTokens } from '@vibesites/theme-sandbox-theme/tokens';

export const tokens: Partial<DesignTokens> = {
  ...parentTokens,
};

export default tokens;
